export default "__VITE_ASSET__BHAyWzQr__"